var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el",staticClass:"cr-tooltip"},[_c('div',{staticClass:"cr-tooltip-arrow"}),_vm._v(" "),_c('div',{staticClass:"cr-tooltip-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }